import { render, staticRenderFns } from "./shipperCreateWareHouse.vue?vue&type=template&id=f4968752&scoped=true&"
import script from "./shipperCreateWareHouse.vue?vue&type=script&lang=js&"
export * from "./shipperCreateWareHouse.vue?vue&type=script&lang=js&"
import style0 from "./shipperCreateWareHouse.vue?vue&type=style&index=0&id=f4968752&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4968752",
  null
  
)

export default component.exports